import PropTypes from 'prop-types'
import useFetchEducationFeatures from '../hooks/useFetchEducationFeatures'

FetchEducationFeatures.propTypes = {
  children: PropTypes.node.isRequired
}

export default function FetchEducationFeatures({ children }) {
  useFetchEducationFeatures()

  return children
}
